import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import CommissionPlansTab from "./CommissionPlansTab";
import { useSearchParams } from "react-router-dom";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const TAB_NAMES: Record<number, string> = {
  0: "Commission Plans",
  1: "Deals",
  2: "Promotion Links",
};

// Reverse lookup: tab name → index
const TAB_INDEX: Record<string, number> = Object.fromEntries(
  Object.entries(TAB_NAMES).map(([idx, name]) => [name, Number(idx)]),
);

const DealsAndPromotionsTabs = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const [value, setValue] = React.useState(
    () => TAB_INDEX[searchParams.get("tabTitle") ?? ""] ?? 0,
  );

  React.useEffect(() => {
    setSearchParams(
      (prev) => {
        prev.set("tabTitle", TAB_NAMES[value] ?? "");
        return prev;
      },
      { replace: true },
    );
  }, [value, setSearchParams]);

  const handleChange = (_: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <>
      <Box sx={{ width: "100%" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
            sx={{
              "& .MuiTab-root": {
                color: "#00000099",

                "&.Mui-selected": {
                  color: "#9C27B0",
                },
              },

              /* Active line color */
              "& .MuiTabs-indicator": {
                backgroundColor: "#9C27B0",
                height: "3px", // optional
                borderRadius: "10px", // optional
              },

              "& .MuiTabs-flexContainer": {
                justifyContent: "flex-start",
              },

              "& .MuiTab-root:first-of-type": {
                paddingLeft: 1.5,
              },
            }}
          >
            <Tab label="Commission Plans" {...a11yProps(0)} />
            <Tab label="Deals" {...a11yProps(1)} disabled />
            <Tab label="Promotion Links" {...a11yProps(2)} disabled />
          </Tabs>
        </Box>
        <CustomTabPanel value={value} index={0}>
          <CommissionPlansTab />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          --
        </CustomTabPanel>
        <CustomTabPanel value={value} index={2}>
          --
        </CustomTabPanel>
      </Box>
    </>
  );
};

export default DealsAndPromotionsTabs;
